import { AirportFboType } from '@/api/apis/facilities';

export const getFboName = (fbo: AirportFboType) => {
  const addressLine = fbo.addresses[0]?.addressLine || fbo.addresses[0]?.addressLine1 || fbo.addresses[0]?.addressLine2;

  return `${fbo.name}, ${addressLine}, ${fbo.addresses[0]?.city}`;
};
